module.exports = __webpack_public_path__ + "media/images/icons/filled/project-7496b799ff821b0f64b882cf2da1c730.svg";